import { environment } from 'src/environments/environment';

export type WizardBrandKey =
  | 'default'
  | 'cncs'
  | 'ssdg'
  | 'msdg'
  | 'agrivoltaic-one'
  | 'agrivoltaic-two';

export interface WizardBrandingMetadata {
  key: WizardBrandKey;
  routeSegment: string;
  displayName: string;
  logoSrc: string | null;
  logoAlt: string;
  wordmarkText?: string;
  primaryColor: string;
  primaryColorDark: string;
}

const cncsBranding: WizardBrandingMetadata = {
  key: 'cncs',
  routeSegment: 'cncs',
  displayName: 'CNCS',
  logoSrc: `${environment.cncsCoreUrl}/images/logo-dark.png`,
  logoAlt: 'CNCS',
  primaryColor: 'oklch(0.28 0.09 255)',
  primaryColorDark: 'oklch(0.2 0.09 255)',
};

export const WIZARD_BRANDING_METADATA: Record<WizardBrandKey, WizardBrandingMetadata> = {
  default: cncsBranding,
  cncs: cncsBranding,
  ssdg: {
    key: 'ssdg',
    routeSegment: 'ssdg',
    displayName: 'SSDG',
    logoSrc: cncsBranding.logoSrc,
    logoAlt: cncsBranding.logoAlt,
    primaryColor: 'oklch(0.28 0.09 255)',
    primaryColorDark: 'oklch(0.2 0.09 255)',
  },
  msdg: {
    key: 'msdg',
    routeSegment: 'msdg',
    displayName: 'MSDG',
    logoSrc: cncsBranding.logoSrc,
    logoAlt: cncsBranding.logoAlt,
    primaryColor: 'oklch(0.28 0.09 255)',
    primaryColorDark: 'oklch(0.2 0.09 255)',
  },
  'agrivoltaic-one': {
    key: 'agrivoltaic-one',
    routeSegment: 'agrivoltaic-one',
    displayName: 'Agrivoltaic One',
    logoSrc: cncsBranding.logoSrc,
    logoAlt: cncsBranding.logoAlt,
    primaryColor: 'oklch(0.28 0.09 255)',
    primaryColorDark: 'oklch(0.2 0.09 255)',
  },
  'agrivoltaic-two': {
    key: 'agrivoltaic-two',
    routeSegment: 'agrivoltaic-two',
    displayName: 'Agrivoltaic Two',
    logoSrc: cncsBranding.logoSrc,
    logoAlt: cncsBranding.logoAlt,
    primaryColor: 'oklch(0.28 0.09 255)',
    primaryColorDark: 'oklch(0.2 0.09 255)',
  },
};
